import { useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import useStyles from "./styles";
import { AltaContext } from "../../../../../context";
import { FailedTableInfo } from "../failedTableInfo";

export const InfoTableHighRisk = ({ title, rows }) => {
  const { badPersons } = useContext(AltaContext);
  const classes = useStyles();

  const persons = rows ?? [];
  const summary = rows?.[0] ?? {};

  return (
    <div className={classes.container}>
      {!!badPersons.length && <FailedTableInfo rows={badPersons} />}

      <div className={classes.headerComponent}>
        <Typography variant="h6" className={classes.title} align="left">
          <strong>{title}</strong>
        </Typography>
      </div>

      {!persons.length ? (
        <Typography className={classes.emptyState}>
          No hay asegurados guardados
        </Typography>
      ) : (
        <div className={classes.tableWrapper}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>Nombre</TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Categoría
                </TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Sexo
                </TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Fecha de Nacimiento
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {persons.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.cell}>{row.nombre}</TableCell>
                  <TableCell className={classes.cell} align="center">
                    {row.newCategory ?? row.categoriaDesc ?? row.categoria}
                  </TableCell>
                  <TableCell className={classes.cell} align="center">
                    {row.sexo}
                  </TableCell>
                  <TableCell className={classes.cell} align="center">
                    {row.fechainicial ?? row.fchNacimineto ?? row.fchNacimiento}
                  </TableCell>
                </TableRow>
              ))}

              <TableRow className={classes.summaryRow}>
                <TableCell className={classes.cell} />
                <TableCell className={classes.summaryLabel} align="center">
                  Importe póliza Anterior
                </TableCell>
                <TableCell className={classes.summaryLabel} align="center">
                  Nuevo importe póliza
                </TableCell>
                <TableCell className={classes.summaryLabel} align="center">
                  Diferencia de monto
                </TableCell>
              </TableRow>
              <TableRow className={classes.summaryRow}>
                <TableCell className={classes.cell} />
                <TableCell className={classes.cell} align="center">
                  {summary.importeAnterior || ""}
                </TableCell>
                <TableCell className={classes.cell} align="center">
                  {summary.importeActual || ""}
                </TableCell>
                <TableCell className={classes.cell} align="center">
                  {summary.importeDiferencia || 0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
